export default __webpack_public_path__ + "static/media/phone.64084340.svg";